import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';

const campaigns = accountId => ({
  parentNav: 'campaigns',
  routes: [
    'settings_account_campaigns',
    'one_off',
    'whatsapp_campaigns',
    'email_campaigns',
    'smart_ai_email_campaign',
    'smart_ai_email_campaign_contacts',
  ],
  menuItems: [
    {
      key: 'whatsappCampaigns',
      icon: 'whatsapp',
      label: 'WHATSAPP',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/whatsapp_campaigns`),
      toStateName: 'whatsapp_campaigns',
    },
    {
      key: 'emailCampaigns',
      icon: 'mail',
      label: 'EMAIL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/email_campaigns`),
      toStateName: 'email_campaigns',
    },
    {
      icon: 'arrow-swap',
      label: 'ONGOING',
      key: 'ongoingCampaigns',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/ongoing`),
      toStateName: 'settings_account_campaigns',
    },
    {
      key: 'oneOffCampaigns',
      icon: 'sound-source',
      label: 'ONE_OFF',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/one_off`),
      toStateName: 'one_off',
    },
    {
      key: 'smartAiEmailCampaigns',
      icon: 'mail',
      label: 'SMART_AI_EMAIL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/smart_ai_email_campaign`),
      toStateName: 'smart_ai_email_campaign',
      featureFlag: FEATURE_FLAGS.SMART_AI_EMAIL_CAMPAIGN,
    },
  ],
});

export default campaigns;
